import { get } from 'lodash';
import { AxiosClient } from 'src/configs/axios/axios';

const PAGE_SESSION_API = {
  listPageSessionAPI: async (params: PageSession.GetListPageSessionParams) => {
    const response = await new AxiosClient().get('/page/session', { params })
    return get(response, 'data', null)
  },
  detailPageSessionAPI: async (id: string) => {
    const response = await new AxiosClient().get(`/page/session/${id}`)
    return get(response, 'data', null)
  },
  createPageSessionAPI: async (params: PageSession.PageSessionPostDetailParams) => {
    const response = await new AxiosClient().post('/page/session', params)
    const data = get(response, 'data', null)
    return data
  },
  updatePageSessionAPI: async (params: PageSession.PageSessionPostDetailParams) => {
    const response = await new AxiosClient().put(
      `/page/session/${params.id}`,
      params
    )
    const data = get(response, 'data', null)
    return data
  },
  deletePageSessionAPI: async (id: string) => {
    const response = await new AxiosClient().delete('/page/session/' + id)
    const data = get(response, 'data', null)
    return data
  },
  listOrderSessionAPI: async (params: PageSession.GetListOrdersParams) => {
    const response = await new AxiosClient().get('/page/session/sort-order', { params })
    const data = get(response, 'data', null)
    return data
  },
  sortOrderSessionAPI: async (params: PageSession.PostSortOrderParams) => {
    const response = await new AxiosClient().put(`/page/session/sort-order/${params.pageId}`, params.orders)
    const data = get(response, 'data', null)
    return data
  },
}

export default PAGE_SESSION_API
